export const folderList = {
  id: 19283,
  name: "root",
  link: "/",
  folder: true,
  children: [
    {
      id: 19284,
      name: "Folder1",
      link: `Folder1`,
      folder: true,
      children: [
        {
          id: 19285,
          name: "file1",
          folder: false,
          link: `file1`,
          children: [],
        },
        {
          id: 192857,
          name: "Folder4",
          folder: true,
          link: "folder4",
          children: [
            {
              id: 19288,
              name: "File5",
              folder: false,
              link: `file5`,
              children: [],
            },
          ],
        },
      ],
    },
  ],
};
